export default __webpack_public_path__ + "static/media/amiens4.db83c680.jpg";